import { Card } from 'react-bootstrap';
import '../assets/scss/components/review-card.scss';

function ReviewCard({ review }) {
    const { name, comment, reviewer_type } = review;

    return (
        <Card className='review-card mx-auto border-0'>
            <Card.Body className="px-4 py-5">
                <p className="quote mb-0 text-start">“</p>
                <Card.Text as="p">{ comment }</Card.Text>
            </Card.Body>
            <Card.Header className="mx-auto px-3 py-3 border">
                <Card.Title as="h6" className="reviewer my-0">{ name }</Card.Title>
                <Card.Subtitle as="p" className="my-0"> { reviewer_type }</Card.Subtitle>
            </Card.Header>
        </Card>
    )
}

export default ReviewCard;
